import axios from "axios"

const BASE_URL = process.env.REACT_APP_API_URL

class DataCompletionApi {
    getIncompleteInstitutions(config) {
        return axios.get(BASE_URL + "/admin/data-completion/incomplete-institutions", config)
    }
}

export default new DataCompletionApi()
